
                    <div class="pop_up">

                      <h2 class="title">Representatives <i class="ti-close" (click)="onClose()"></i></h2>

                        <div class="main_entry rep_alteration pop_grid">
                          <div class="rep_entry"
                          *ngFor="let lessorRep of modalData.transformedLessorRepresentative"
                          style="cursor: pointer;">
                            <p class="number">{{i + 1}}</p>
                            <p class="info"><i class="ti-user"></i>{{lessorRep?.addressBook.Name}}</p>
                            <p class="info"><i class="ti-mobile"></i>{{lessorRep?.addressBook.PhoneNo}}</p>
                            <p class="info"><i class="ti-location-pin"></i>{{lessorRep?.addressBook.Address}}</p>
                            <p class="info"><i class="ti-id-badge"></i>{{lessorRep?.addressBook.AccountNo}}</p>
                            <p class="info"><i class="ti-info"></i>{{lessorRep?.LessorRepTypeName}}</p>
                            <p class="info">
                              <i class="ti-calendar"></i>
                              <span class="from">{{lessorRep?.FromDate | date:'M/d/yyyy'}}</span> -
                              <span class="to">{{lessorRep?.ToDate | date:'M/d/yyyy'}}</span>
                            </p>

                            <!-- <i class="ti-trash"></i> -->
                          </div>
                        </div>


                    </div>
